<template>
  <div id="financials">
      <div v-if="sankeyChartData.length">
        <h1 align="center">Financials</h1>

        <select v-model="date" @change="updateChart()" class="selectbox">
          <option disabled value="">Please select one</option>
          <option v-for="(item,key) in data" :key=key>
            {{key}}
          </option>
        </select>
        <br>
        <dx-sankey :data-source="sankeyChartData" 
          source-field="source"
          target-field="target"
          weight-field="weight"
          width=100%>
          <dx-tooltip
            :enabled="true"
            :customize-link-tooltip="customizeLinkTooltip"
          />
          <dx-node
            :width="8"
            :padding="30"
          />
          <dx-link color-mode="gradient"/>
        </dx-sankey>
        <br>
      </div>
  </div>
</template>
<script>
import axios from 'axios';
// import VueApexCharts from 'vue-apexcharts';
// import { ChartSankey } from 'vue-d2b';
import DxSankey 
,{
  DxTooltip,
  DxNode,
  DxLink
} 
from 'devextreme-vue/sankey';


export default {
  name: 'FinancialComponent',
  components:{
    DxSankey,
    DxTooltip,
    DxNode,
    DxLink,
  },
  props:['ticker'],
  data() {
    return {
      // ticker: 'AAPL',
      data: null,
      selectedData: null,
      date: null,
      sankeyChartData:[],
    }
  },
  // computed: {},
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      let params = {
        'ticker':this.ticker,
      }
      await axios
        // .get('http://127.0.0.1:5000/api/financials', {params:params})
        .get(`${process.env.VUE_APP_DATA_API_HOST}/financials`, {params:params})
        .then(response => {
          this.data = response.data['data']
          let keys = Object.keys(this.data)
          this.date = keys[keys.length-1]
          this.updateChart()
        })
        .catch(e => {
          e
        })
    },
    updateChart() {
      this.selectedData = this.data[this.date]
      // console.log(this.selectedData)
      this.sankeyChartData = [

        {source:'Total Revenue',target:'Cost of Revenue',weight:this.selectedData['Cost Of Revenue']|| 0},
        // {source:'Cost of Revenue',target:'Total Operating Expenses',weight:this.selectedData['Total Operating Expenses']},
        {source:'Total Revenue',target:'Gross Profit',weight:this.selectedData['Gross Profit']|| 0},
       
        {source:'Operating Income or Loss',target:'Income Before Tax',weight:this.selectedData['Income Before Tax'] || 0},        
        {source:'Income Before Tax',target:'Net Income',weight:this.selectedData['Net Income']|| 0},
        {source:'Income Before Tax',target:'Income Tax Expense',weight:this.selectedData['Income Tax Expense']|| 0},
        {source:'Operating Income or Loss',target:'Interest Expense',weight:Math.abs(this.selectedData['Interest Expense']|| 0)},
       
       
       {source:'Total Operating Expenses',target:'Selling General and Administrative',weight:this.selectedData['Selling General Administrative']|| 0},
       {source:'Total Operating Expenses',target:'Research Development',weight:this.selectedData['Research Development']|| 0},

        // {source:'Cost of Revenue',target:'Total Operating Expenses',weight:this.selectedData['Total Operating Expenses']},
        // {source:'Cost of Revenue',target:'Operating Income or Loss',weight:this.selectedData['Operating Income or Loss']},

        // {source:'Operating Income or Loss',target:'Total Other Income/Expenses Net',weight:Math.abs(this.selectedData['Total Other Income Expense Net'])},
        
    


      ]
    },
    customizeLinkTooltip(info) {
      return {
        html: `<b>From:</b> ${info.source}<br/><b>To:</b> ${info.target}<br/><b>Weight:</b> ${info.weight}`
      };
    }
  },
  watch:{
    ticker: function (){
      this.fetchData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #financials {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.selectbox{
  border:1px solid #BBBBBB;
  border-radius: 5px;
  border-color:#BBBBBB;
  /* height:100%; */
}
</style>